import { IPosition } from '../global/position';
import { IFile } from '../global/file';
import { IGeoZone } from '../global/geoZone';
import { IPaginationParams, IEntityList } from '../global/pagination';
import { ISortParams } from '../global/sort';

export enum HubType {
  Airport = 'AIRPORT',
  TrainStation = 'TRAIN_STATION',
  Seaport = 'SEAPORT',
  PointOfInterest = 'POINT_OF_INTEREST',
}

export const HubTypeDisplayName = {
  [HubType.Airport]: 'Airport',
  [HubType.TrainStation]: 'Train Station',
  [HubType.Seaport]: 'Seaport',
  [HubType.PointOfInterest]: 'Point of Interest'
};

export const HubTypesDisplayName = {
  [HubType.Airport]: 'Airports',
  [HubType.TrainStation]: 'Train Stations',
  [HubType.Seaport]: 'Seaports',
  [HubType.PointOfInterest]: 'Points of Interest'
};

export interface IHub {
  id: number;
  name: string;
  position: IPosition;
  hubType: string;
  address: IAddress;
  timeZoneId: string;
  active: boolean;
  currencyCode: string;
  measurementSystem: string;
  minBookWindowHours: number;
  details: IHubDetail[];
  geographicArea: IPosition[];
  geoZones?: IEntityList<IHubGeoZone>;
  managedByUserId: number;
  vatLevel: number;
  meetingPoints: IHubMeetingPoint[];
  overrideJourneysDistributionDefaultPercentages: boolean;
  autoCompleteName: string;
  autoCompleteLocation: string;
}

export interface IHubMeetingPoint {
  id: number;
  hubId: number;
  title: string;
  description: string;
  active: boolean;
  geographicLocation: IPosition;
  mapFileId: number;
  mapFile: IFile;
  image?: any;
}

export interface IAddress {
  streetName: string;
  streetNumber: string;
  formattedAddress: string;
  originalAddress: string;
  city: string;
  postalCode: string;
  region: string;
  countryCode: string;
  establishment: string;
}

export interface IHubDetail {
  code: string;
  value: string;
  name: string;
}

export interface IHubGeoZone extends IGeoZone {
  hubId: string;
}

export interface IHighlightedValue {
  value: string;
}

export interface IHighlightedResult {
  autoCompleteLocation: IHighlightedValue;
  autoCompleteName: IHighlightedValue;
}

export interface IMultilingualHub {
  id: number;
  name: string;
  autoCompleteName: string;
  autoCompleteLocation: string;
  hubType: string;
  position: IPosition;
  countryCode: string;
  highlightedResult: IHighlightedResult;
}

export interface IMultilingualHubsRequestParams extends ISortParams, IPaginationParams {
  query: string;
  preferredLanguage: string;
}

export interface IBookingWindowOverride {
  id?: number;
  created?: string;
  updated?: string;
  hubId: number;
  vehicleConfigurationId?: number;
  minBookWindowHours?: number;
  days: string[];
  timeFrom: string;
  timeTo: string;
}

export interface ICopyGeoZonesParams {
  sourceHubId: number;
  destinationHubId: number;
}
